import { CircularProgress } from '@mui/material'
import React from 'react'

function Loader({ showLoader }) {
  return showLoader ? <CircularProgress size={24} /> : undefined
}

export default React.memo(Loader)
